import './src/styles/global.css';

import commonWrapPageElement from './_gatsby/wrapPageElement';

export const wrapPageElement = commonWrapPageElement;
